import React from "react";
import { Button, Container, Row, Col, UncontrolledTooltip } from "reactstrap";

function Collegamenti() {
  return (
    <>
      <div className="section">
        <Container className="text-center">
          <Row className="justify-content-md-center sharing-area text-center">
            {/* Inizio del testo */}
            <Col className="text-center" lg="8" md="12">
              <h3>Seguimi anche su:</h3>
            </Col>
            {/* Fine del testo */}

            {/* Inizio dei collegamenti */}
            <Col className="text-center" lg="8" md="12">

              {/* Inizio Instagram */}
              <Button className="sharrre btn-round ml-2" color="instagram-bg" href="https://www.instagram.com/matti_bracco/" target="new" id="tooltip68961360">
                <i className="fa fa-instagram" /> Instagram
              </Button>
              <UncontrolledTooltip delay={0} target="tooltip68961360">
                Seguimi su Instagram
              </UncontrolledTooltip>
              {/* Fine Instagram */}
              
              {/* Inizio GitHub */}
              <Button className="sharrre btn-round ml-2" color="github-bg" href="https://github.com/MattiaBracco05" target="new" id="tooltip864353654">
                <i className="fa fa-github" /> GitHub
              </Button>
              <UncontrolledTooltip delay={0} target="tooltip864353654">
                Seguimi su Github
              </UncontrolledTooltip>
              {/* Fine GitHub */}

            </Col>
            {/* Fine dei collegamenti */}
          
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Collegamenti;
